/**
 * Update a password requirements list to show if each requirement is being met
 * Requires a standard <ul><li> list, also accepts nested lists. Example:
 * 
 *		<p class="text-sm my-2">Your password must:</p>
 *		<ul class="js-password-requirements fa-ul text-sm">
 *			<li data-requirement="^.{6,80}$">#iconList("fa-circle-dot") Be between 6 and 80 characters</li>
 *			<li>#iconList("fa-circle-dot") Include all of the following:
 *				<ul class="fa-ul">
 *					<li data-requirement="[A-Z]+">#iconList("fa-circle-dot") An uppercase character (A-Z)</li>
 *					<li data-requirement="[a-z]+">#iconList("fa-circle-dot") A lowercase character (a-z)</li>
 *					<li data-requirement="[0-9]+">#iconList("fa-circle-dot") A number (0-9)</li>
 *					<li data-requirement="[^A-Za-z0-9]+">#iconList("fa-circle-dot") A special character (such as ? ! & @ £)</li>
 *				</ul>
 *			</li>
 *		</ul>
 */

export default class PasswordRequirements {
	constructor(args) {
		this.input = args.input || null;
		this.requirementsList = $(".js-password-requirements");

		if(!this.input.length || !this.requirementsList.length) return;

		this.input.on("change keydown keyup", this.onInputChange.bind(this));
		this.hasTypedPassword = false;
		this.isInvalid = false;
	}

	onInputChange() {
		// Only starts the checks once they've typed characters (rather than pressing up arrow, shift key etc)
		if(this.input.val().length) {
			this.hasTypedPassword = true;
		}

		if(this.hasTypedPassword) {
			this.checkRequirements();
			this.checkSubRequirements();
			this.setOverallValidity();
		}
	}

	// Check each <li> should be marked as valid
	checkRequirements() {
		this.requirementsList.find("li").each((i, requirement) => {
			const regex = $(requirement).data('requirement');
			if(!regex) return;
			const isValid = this.input.val().match(regex) != null;
			this.markStatus($(requirement), isValid);
		});
	}

	// If there's a nested <ul>, mark as valid if *all* it's <li> are also marked as valid
	checkSubRequirements() {
		// Reset overall status
		this.isInvalid = false;

		this.requirementsList.find("ul").each((i, requirement) => {
			const isValid = $(requirement).find("li[data-valid=false]").length == 0;
			this.markStatus($(requirement), isValid);

			if(!isValid) {
				this.isInvalid = true;
			}
		});
	}

	markStatus(requirement, isValid) {
		const listItem = requirement[0].nodeName == "UL" ? requirement.parent() : requirement;
		listItem.attr("data-valid", isValid);
		listItem.toggleClass("text-green", isValid);
		listItem.toggleClass("text-red no-clear", !isValid); // .no-clear is to stop conflict with ajax-form-error-handler errors

		const icon = listItem.find("> .fa-li svg");
		icon.removeClass("fa-circle-dot");
		icon.toggleClass("fa-circle-check", isValid);
		icon.toggleClass("fa-circle-xmark", !isValid);
	}

	setOverallValidity() {
		this.input.attr("aria-invalid", this.isInvalid);
	}
}
